// src/components/SignupScreen/SignupScreen.js
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from '../../context/AuthContext';
import gmailAPI from "../../api/gmail";
import { companiesAPI } from "../../api/companies";
import authAPI from "../../api/auth";
import { onboardingAPI } from "../../api/onboarding";

const SetupSteps = [
    "Adding your companies",
    "Embedding AI data",
    "Adding AI context"
];

const SignupScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, setUser } = useAuth();
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [setupComplete, setSetupComplete] = useState(false);
    const [currentStepMessage, setCurrentStepMessage] = useState('');



    // Handle OAuth redirect callback
    // useEffect(() => {
    //     const params = new URLSearchParams(window.location.search);
    //     const token = params.get('token');

    //     if (token) {
    //         setUser({ token });
    //         window.history.replaceState({}, document.title, window.location.pathname);
    //     }
    // }, [setUser]);

    // Handle setup steps animation
    // useEffect(() => {
    //     if (currentStepIndex < SetupSteps.length) {
    //         const timer = setTimeout(() => {
    //             setCurrentStepIndex(prev => prev + 1);
    //         }, 1000);

    //         return () => clearTimeout(timer);
    //     } else {
    //         setSetupComplete(true);
    //     }
    // }, [currentStepIndex]);

    // Handle navigation after setup
    // useEffect(() => {
    //     if (setupComplete) {
    //         navigate('/companies', { replace: true });
    //     }
    // }, [setupComplete, navigate]);



    // const onboardingHandler = async () => {
    //     // setSavingData(true);
    //     try {
    //         await gmailAPI.chunkAllEmails();
    //         await companiesAPI.createCompaniesFromEmails();
    //         await companiesAPI.updateAllCompanyFields();
    //         await authAPI.onboarding();
    //         const response = await authAPI.onboarding();
    //         console.log(`response onboarding`, response);
    //         if (response?.statusCode === 200) {
    //             localStorageSetterHandler();
    //             navigate('/signup')
    //         }
    //     } catch (error) {
    //         console.log("Error in onboarding :", error);
    //     } finally {
    //         // setSavingData(false);
    //     }
    // };


    const onboardingHandler = async () => {
        const steps = [
            { api: onboardingAPI.chunkAllEmails, message: "Processing emails..." },
            { api: onboardingAPI.createCompaniesFromEmails, message: "Creating companies..." },
            { api: onboardingAPI.updateAllCompanyFields, message: "Updating company details..." },
            { api: onboardingAPI.initializeContacts, message: "Creating key contacts..." },
            { api: onboardingAPI.finalizeOnboarding, message: "Finalizing onboarding..." },
            

            // { api: gmailAPI.chunkAllEmails, message: "Processing emails..." },
            // { api: companiesAPI.createCompaniesFromEmails, message: "Creating companies..." },
            // { api: companiesAPI.updateAllCompanyFields, message: "Updating company details..." },
            // { api: gmailAPI.initializeContacts, message: "Creating key contacts..." },
            // { api: authAPI.onboarding, message: "Finalizing onboarding..." }
        ];

        for (let i = 0; i < steps.length; i++) {
            // await new Promise(resolve => setTimeout(resolve, 500)); // Ensure UI updates before next step
            // setCurrentStepIndex(prev => prev + 1);
            setCurrentStepMessage(steps[i].message)
            // console.log(steps[i].message);

            try {
                const response = await steps[i].api();
                console.log(`Step ${i + 1} completed:`, response);
                if (response?.statusCode !== 200) {
                    console.error(`Step ${i + 1} failed. Stopping process.`);
                    return;
                } else {
                    // setCurrentStepIndex(prev => prev + 1);
                }
            } catch (error) {
                console.error(`Error in step ${i + 1}:`, error);
                return;
            }
        }

        setSetupComplete(true);
        console.log("Onboarding completed successfully.");
    };

    // Handle navigation after setup completion
    useEffect(() => {
        if (setupComplete) {
            localStorage.setItem("isUserOnboardingDone", true);
            navigate('/companies', { replace: true });
        }
    }, [setupComplete, navigate]);

    useEffect(() => {
        onboardingHandler();
    }, [])


    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="text-center p-8">
                {/* CSS Spinner */}
                <div className="w-12 h-12 border-4 border-purple-600 border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                    Setting up your workspace
                </h2>
                <p className="text-lg text-gray-600">
                    {/* {currentStepIndex < SetupSteps.length ? SetupSteps[currentStepIndex] : "Setup complete!"} */}
                    {currentStepMessage}
                </p>
            </div>
        </div>
    );
};

export default SignupScreen;